import React from "react";
import { FormattedMessage } from "react-intl";
import { Grid } from "semantic-ui-react";
import PatternBox from "../../screens/Patterns/PatternBox";
import styles from "./PatternGrid.module.scss"
import { useNavigate } from "react-router-dom";

type Props = {
	patterns: any[];
	variant?: "owner" | "buyer";
};

const PatternGrid: React.FC<Props> = ({ patterns, variant = "owner" }) => {
	const navigate = useNavigate();
	if (!Array.isArray(patterns)) return null;

	return (
		<Grid className={styles.container}>
			{patterns.length === 0 ? (
				<div className={styles.noPattern}>
					<h3>
						<FormattedMessage id="patternGrid.noPatternsTitle" defaultMessage="No Patterns Found" />
					</h3>

					<p>
						<FormattedMessage
							id="patternGrid.noPatternsMessage"
							defaultMessage="You haven’t created any patterns yet. Start by adding your first pattern."
						/>
					</p>

					<button
						className={styles.button}
						onClick={() => navigate('/manage-pattern')}
					>
						<FormattedMessage id="patternGrid.createPattern" defaultMessage="Create Pattern" />
					</button>
				</div>
			) :
				(patterns.map((pattern: any) => (
					<Grid.Column
						key={pattern._id}
						mobile={16}
						tablet={10}
						computer={8}
					>
						<PatternBox pattern={pattern} variant={variant} />
					</Grid.Column>
				)))}
		</Grid>
	);
};

export default PatternGrid;